
























import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import {
  GET_PROJECTS,
  GET_SELECTED_PROJECTS,
  GET_IS_CONNECTED
} from '@/system/store/getter-types'
import { IActionType } from '@/system/store'
import { SYSTEM_TYPES_LABEL, ALL_PROJECT_TYPES, PROJECT_SYSTEM_TYPES } from '@/constants'
import { SET_SELECTED, FETCH_PROJECT_LIST_ACTION } from '@/system/store/action-types'
import { IProjectItem, ISelectedProjects, IProjectItemsGetterResult } from '@/features/projectList/store'
import { projectListLocalisationKeys } from '@/features/projectList/projectList.localisation'
import HandleLoaders from '@/shared/HandleLoaders.component.vue'
import Notification from '@/shared/Notification.mixin.vue'

@Component
export default class ProjectList extends Mixins(HandleLoaders, Notification) {
  private translations = projectListLocalisationKeys
  private selected: any[] = []
  private pagination = {
    rowsPerPage: 0
  }
  private columns = [{
    field: ({ nameByCustomer }: IProjectItem) => nameByCustomer,
    align: 'left'
  }, {
    field: ({ system }: IProjectItem) => SYSTEM_TYPES_LABEL[system],
    align: 'right'
  }]

  @Getter(GET_PROJECTS)
  projectList!: IProjectItemsGetterResult
  @Getter(GET_SELECTED_PROJECTS)
  selectedProjects!: ISelectedProjects[]
  @Action(SET_SELECTED)
  setSelected!: IActionType
  @Action(FETCH_PROJECT_LIST_ACTION)
  fetchProjectList!: IActionType

  @Watch('projectList')
  projectsLoaded () {
    this.hideLoader()

    if (this.projectList.$error && this.projectList.$errorReason === 'NO_PROJECTS_FOUND') {
      this.showError(this.$t(this.projectList.$errorReason) as string)
    }
  }

  @Watch('selected', { immediate: true })
  checkSelctedProjects (value: IProjectItem[]): void {
    const projects = value.map(({ id, system }) => ({ id, system }))
    this.setSelected(projects)
  }

  private created (): void {
    const _this = this
    this.showDualRingSpinner()
    this.$store.watch((state, getters) => getters[GET_IS_CONNECTED],
      (newValue: boolean) => {
        if (newValue) {
          _this.fetchProjectList()
        }
      }, { immediate: true })
  }
}
